import { HelpService } from '../../help/help.service';
import { TipoUsuario } from '../../types/LoginResponse.type';
import { ItemMenu, filtrarPorRoles, itensPorPerfil } from './app.menu.itens';

/**
 * Grupos do menu lateral do usuário. A Ajuda fica fora: ela tem botão próprio no rodapé da barra lateral.
 */
export function montarMenu(tipo: TipoUsuario | null | undefined, roles: readonly string[], help?: HelpService): ItemMenu[] {
    // Segurança depende do tipo do usuário, que é o que o auth-service usa para autorizar essas telas
    const seguranca: ItemMenu[] = tipo === 'ADMIN_SISTEMA' ? [
        {
            label: 'Licenciamento',
            icon: 'pi pi-verified',
            items: [
                { label: 'Clientes', icon: 'pi pi-building', routerLink: ['/pages/seguranca/clientes'] },
                { label: 'Módulos', icon: 'pi pi-sitemap', routerLink: ['/pages/seguranca/modulos'] },
                { label: 'Ações', icon: 'pi pi-key', routerLink: ['/pages/seguranca/acoes'] },
                { label: 'Regiões', icon: 'pi pi-map', routerLink: ['/pages/seguranca/regioes'] },
                { label: 'Instâncias', icon: 'pi pi-server', routerLink: ['/pages/seguranca/instancias'] },
                { label: 'Parâmetros', icon: 'pi pi-sliders-h', routerLink: ['/pages/seguranca/parametros'] },
                { label: 'Ambientes', icon: 'pi pi-database', routerLink: ['/pages/seguranca/ambientes'] }
            ]
        },
        { label: 'Perfis', icon: 'pi pi-id-card', routerLink: ['/pages/seguranca/perfis'] },
        { label: 'Funções', icon: 'pi pi-list', routerLink: ['/pages/seguranca/funcoes'] },
        { label: 'Usuários', icon: 'pi pi-users', routerLink: ['/pages/seguranca/usuarios'] }
    ] : tipo === 'ADMIN_CLIENTE' ? [
        { label: 'Perfis', icon: 'pi pi-id-card', routerLink: ['/pages/seguranca/perfis'] },
        { label: 'Usuários', icon: 'pi pi-users', routerLink: ['/pages/seguranca/usuarios'] }
    ] : [];
    // Demais seções: o admin do sistema vê todas; os outros, só as liberadas pelos módulos dos seus perfis
    const itens = itensPorPerfil(help).filter(item => item.role !== 'AJUDA');
    const permitidos = tipo === 'ADMIN_SISTEMA' ? itens : filtrarPorRoles(itens, new Set(roles));
    return [
        { label: 'Home', icon: 'pi pi-home', items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }] },
        ...permitidos,
        ...(seguranca.length ? [{ label: 'Segurança', icon: 'pi pi-shield', items: seguranca }] : [])
    ];
}
